__webpack_require__.p = "/wp-content/data-viz/ro/middle-east/";